/**
 * User: Rob Richard
 * Date: 11/25/14
 * Time: 6:06 PM
 */

'use strict';

var strings = require('./strings');
var shard;

/**
 * Get an index number based on the string to be used against an array
 * @param {string} stringVal An image path
 * @returns {number}
 */
var computeChecksum = function (stringVal) {
    // check for a string otherwise default to an empty array for the return statement
    var vals = typeof stringVal === 'string' ? stringVal.split('') : [];
    return vals.reduce(function (checksum, letter) {
        return checksum + strings.ord(letter);
    }, 0);
};

/**
 * Gets the domain to prepend to an image
 * @param {string} filePath The current path to process
 * @param {array} imageHosts Array of host names
 * @returns {string}
 */
var getDomain = function (filePath, imageHosts) {
    var index;
    var checksum;
    console.assert(Array.isArray(imageHosts), 'shard.getDomain requires an array of imageHosts');

    checksum = computeChecksum(filePath);
    index = checksum % imageHosts.length;

    return imageHosts[index];
};


shard = module.exports = {
    /**
     * Get the fully qualified domain if all the required params are passed along
     * By default, the returned value is scheme-less
     * @param {string} filePath The file path to add the shard to
     * @param {array} imageHosts Array of shard domain strings
     * @param {boolean} [prependProtocol=false] Force adding the protocol
     * @returns {string|*}
     */
    getUrl: function (filePath, imageHosts, prependProtocol) {
        // FINDING-6978 ignore any further processing if https? is in the filePath
        var regexp = /^https?/i;
        if (regexp.test(filePath) || !filePath) {
            return filePath;
        }
        if (imageHosts) {
            return (prependProtocol ? 'https:' : '') + '//' + getDomain(filePath, imageHosts) + filePath;
        }
        return filePath;
    }
};



//////////////////
// WEBPACK FOOTER
// ./~/bunsen/helpers/shard.js
// module id = 702
// module chunks = 64